import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const Wrapper = styled.div`
  z-index: 100;
  position: fixed;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  ${mediaQuery('phone')} {
    display: none;
  }
`;

export const SOCIAL_BUTTON_COLOR: Record<'instagram' | 'facebook', string> = {
  facebook: '#3b5998',
  instagram: '#262626',
};

export const SocialButton = styled.a<{ type: 'instagram' | 'facebook' }>`
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: white;
  background: ${(props) => SOCIAL_BUTTON_COLOR[props.type]};
  transition-property: all;
  transition-duration: ${(props) => props.theme.transition.duration.default};
  transition-timing-function: ${(props) => props.theme.transition.function.default};
  &:hover {
    cursor: pointer;
    width: calc(35px * 1.2);
  }
`;
